import { gql } from '@apollo/client';
import { OrderInfoShared } from '@retainerclub/shared-api';

export default gql`
  query ordersDiscounted(
    $partnerLocationId: ID
    $partnerOrganizationId: ID
  ) {
    ordersDiscounted(
      partnerLocationId: $partnerLocationId
      partnerOrganizationId: $partnerOrganizationId
    ) {
      ...OrderInfoShared
    }
  }
  ${OrderInfoShared}
`;
